import { createReport } from "../../../../../services/reportService";

/**
 * Report a post in Firebase
 * @param {Object} params - Report parameters
 */
export const reportPostInFirebase = async (params) => {
  const {
    postId,
    itemType = "post",
    reasonCategory,
    reasonText = "",
    userId,
    postAuthorId = null,
  } = params || {};

  if (!postId || !reasonCategory || !userId) {
    throw new Error("Missing required report data");
  }

  try {
    await createReport({
      postId,
      itemType,
      reasonCategory,
      reasonText,
      userId,
      postAuthorId,
    });
  } catch (error) {
    console.error("Error reporting post:", error);
    throw error;
  }
};
